// @flow
import moment from 'moment';
import React from 'react';
import styled from 'styled-components';
import { DatePicker } from '../../../components/ant/DatePicker';

import { Filter, FilterButtonsContainer, FilterContainer, FilterItem, Selects } from './../../../components';
import Field from './../../../components/card/Field';
import type { FilterChildrenParams } from './../../../components/hoc/Filter';
import { formatDateTimeToISOString } from './../../../lib/helpers';

import type { OsagoCalculationStatus } from './../../../lib/types';

const { OsagoCalculationStatusSelect, YearSelect } = Selects;

const SpoilerContent = styled.div`
  padding: 16px;
`;

export type FilterYearsParams = {
  status?: OsagoCalculationStatus,
  year?: number,
  endDate?: string,
  created?: string
};

type Props = {
  filter: FilterYearsParams,
  cleanFilter: Function,
  applyFilter: Function
};

export default ({ filter, cleanFilter, applyFilter }: Props) => (
  <SpoilerContent>
    <FilterContainer>
      <Filter
        cleanFilter={cleanFilter}
        applyFilter={applyFilter}
        initialValues={filter}
      >
        {({
          values,
          changeValue,
          applyFilter,
          cleanFilter
        }: FilterChildrenParams<FilterYearsParams>) => (
          <>
            <FilterItem>
              <Field mBottomNone>
                <OsagoCalculationStatusSelect
                  size="small"
                  onChange={value => changeValue('status', value)}
                  value={values.status}
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <DatePicker
                  size="small"
                  format="DD.MM.YYYY"
                  value={values.created && moment.utc(values.created)}
                  placeholder="Дата создания карточки"
                  onChange={(value: Object, dateString: string) =>
                    changeValue(
                      'created',
                      formatDateTimeToISOString(value, dateString)
                    )
                  }
                />
              </Field>
            </FilterItem>
            <FilterItem>
              <Field mBottomNone>
                <YearSelect
                  size="small"
                  onChange={value => changeValue('year', value)}
                  value={values.year}
                />
              </Field>
            </FilterItem>

            <FilterButtonsContainer
              applyFilter={applyFilter}
              cleanFilter={cleanFilter}
            />
          </>
        )}
      </Filter>
    </FilterContainer>
  </SpoilerContent>
);
